import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import MonthFilter from "../../hooks/MonthFilter";

const apiUrl = process.env.REACT_APP_API_URL;

function EthioOthers() {
  const [totalPrice, setTotalPrice] = useState("");
  const [filterModel, setFilterModel] = useState("");
  const [filterMonth, setFilterMonth] = useState("");
  const [filterDay, setFilterDay] = useState("");
  const [filterStatusP, setFilterStatusP] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [data, setData] = useState([]);
  const [otherData, setOtherData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState(null);
  const [totalSent, setTotalSent] = useState("");
  const [totalReceivedCal, setTotalReceivedCal] = useState("");
  const [totalOrder, setTotalOrder] = useState("");
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear()); // Added for year filter

  const userId = localStorage.getItem("token");

  let totalYuanSum = 0;
  let totalProfit = 0;

  const [dropdownOpen, setDropdownOpen] = useState(null);
  const [dropdownOpenSeller, setDropdownOpenSeller] = useState(null);

  // Separate refs for each dropdown
  const dropdownRefSeller = useRef(null);
  const dropdownRef = useRef(null);

  const toggleDropdown = (index) => {
    setDropdownOpen(dropdownOpen === index ? null : index);
  };

  const toggleDropdownSeller = (index) => {
    setDropdownOpenSeller(dropdownOpenSeller === index ? null : index);
  };

  // Handle clicking outside for all dropdowns
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setDropdownOpen(null);
    }
    if (
      dropdownRefSeller.current &&
      !dropdownRefSeller.current.contains(event.target)
    ) {
      setDropdownOpenSeller(null);
    }
  };

  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const monthToNumber = (month) => {
    const months = {
      Jan: 1,
      Feb: 2,
      Mar: 3,
      Apr: 4,
      May: 5,
      Jun: 6,
      Jul: 7,
      Aug: 8,
      Sep: 9,
      Oct: 10,
      Nov: 11,
      Dec: 12,
    };
    return months[month] || 0;
  };

  const currentMonthShortForm = () => {
    const monthIndex = new Date().getMonth(); // Get current month index (0-11)
    return months[monthIndex];
  };

  const [selectedMonth, setSelectedMonth] = useState(currentMonthShortForm()); // Initialize to current month

  // Get current month in short form

  const parseMonthFromOrderNumber = (orderNumber) => {
    const monthPart = orderNumber.startsWith("EOP")
      ? orderNumber.slice(3, 6)
      : orderNumber.slice(0, 3);
    return monthPart.toUpperCase();
  };

  const sortByOrderNumber = (data) => {
    return data.sort((a, b) => {
      const [aMonth, aNumber] = [
        parseMonthFromOrderNumber(a.OrderNumber),
        parseInt(a.OrderNumber.slice(-2)),
      ];
      const [bMonth, bNumber] = [
        parseMonthFromOrderNumber(b.OrderNumber),
        parseInt(b.OrderNumber.slice(-2)),
      ];
      const aMonthNum = monthToNumber(aMonth);
      const bMonthNum = monthToNumber(bMonth);

      if (aMonthNum !== bMonthNum) {
        return bMonthNum - aMonthNum; // Sort by month first (descending)
      }
      return bNumber - aNumber; // Then by number (descending)
    });
  };

  const filterByMonthAndYear = (
    month = currentMonthShortForm(),
    year = new Date().getFullYear()
  ) => {
    setSelectedMonth(month);
    setSelectedYear(year);
    const filtered = applyFilters(data, month, year);
    setFilteredData(filtered);

    const sum = filtered.reduce(
      (acc, item) => acc + parseFloat(item.Price || 0),
      0
    );
    const receivedTotal = filtered.filter(
      (item) => item.Status === "Received"
    ).length;
    const sentTotal = filtered.filter((item) => item.Status === "Sent").length;
    const ordered = filtered.length;

    setTotalPrice(sum);
    setTotalReceivedCal(receivedTotal);
    setTotalSent(sentTotal);
    setTotalOrder(ordered);
  };

  const filterDataByYear = (data, year) => {
    return data.filter((item) => {
      const itemYear = new Date(item.TimeStamp).getFullYear();
      return itemYear === parseInt(year, 10);
    });
  };

  const filterDataByMonth = (data, month) => {
    const monthUpper = month.toUpperCase();
    return data.filter(
      (item) => parseMonthFromOrderNumber(item.OrderNumber) === monthUpper
    );
  };
  // const filterDataByMonth = (data, month) => {
  //   return data.filter((item) => item.OrderNumber.startsWith(month));
  // };

  const handleYearChange = (event) => {
    const year = event.target.value;
    filterByMonthAndYear(selectedMonth, year);
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${apiUrl}/ethioOtherItems`);
      const fetchedData = response.data.map((item) => ({
        ...item,
        imageUrl1: `${apiUrl}/uploads/${item.ImageFilename1}`,
        imageUrl2: `${apiUrl}/uploads/${item.ImageFilename2}`,
      }));
      const sortedData = sortByOrderNumber(fetchedData);
      setData(sortedData);
      setLoading(false);
      return sortedData; // return this
    } catch (error) {
      setLoading(false);
      setErrors(error.response?.data?.message || "An error occurred");
      return []; // return this
    }
  };

  const updateStatus = async (itemId, ourStat) => {
    try {
      setLoading(true);
      await axios.put(`${apiUrl}/updateOurStatEthioOther`, {
        id: itemId,
        ourStat,
      });
      setLoading(false);
      // Fetch updated data after successful status update
      fetchData();
    } catch (error) {
      setLoading(false);
      setErrors(error.response?.data?.message || "An error occurred");
    }
  };

  const handleOptionSelect = (index, itemId, ourStat) => {
    setDropdownOpen(null); // Close the dropdown

    // Update the status in the frontend optimistically
    setData(
      data.map((item) =>
        item.ID === itemId ? { ...item, ourStat: ourStat } : item
      )
    );

    // Update the status in the backend
    updateStatus(itemId, ourStat);
  };

  useEffect(() => {
    const loadAndFilter = async () => {
      const sorted = await fetchData(); // Get full data
      const currentMonth = currentMonthShortForm(); // e.g. "Jun"
      const filtered = sorted.filter((item) =>
        item.OrderNumber.startsWith(`EOP${currentMonth}`)
      );
      setFilteredData(filtered); // set it directly
      setSelectedMonth(currentMonth); // reflect on UI
    };

    loadAndFilter();
  }, []);

  // Extend applyFilters
  const applyFilters = (data, month, year, day, status, model) => {
    let filtered = [...data];

    // Year filter (only if year is provided)
    if (year) {
      filtered = filtered.filter((item) => {
        const itemYear = new Date(item.TimeStamp).getFullYear();
        return itemYear === parseInt(year, 10);
      });
    }

    // Month filter (only if month is provided)
    if (month) {
      const monthUpper = month.toUpperCase();
      filtered = filtered.filter(
        (item) => parseMonthFromOrderNumber(item.OrderNumber) === monthUpper
      );
    }

    // Day filter
    if (day) {
      filtered = filtered.filter((item) => {
        const itemDay = new Date(item.TimeStamp).getDate();
        return itemDay === parseInt(day, 10);
      });
    }

    // Status filter
    if (status) {
      filtered = filtered.filter((item) => item.ourStat === status);
    }

    // Model filter
    if (model) {
      filtered = filtered.filter((item) =>
        item.ItemName?.toLowerCase().includes(model.toLowerCase())
      );
    }

    return filtered;
  };
  useEffect(() => {
    if (data.length > 0) {
      const filtered = applyFilters(
        data,
        selectedMonth,
        selectedYear,
        filterDay,
        filterStatusP,
        filterModel
      );
      setFilteredData(filtered);
    }
  }, [data, selectedMonth, selectedYear, filterDay, filterStatusP, filterModel]);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Adjust this to your preference

  const [initialData, setInitialData] = useState({}); // Store the initial row data when editing starts

  const [isEditing, setIsEditing] = useState(null);
  const [editData, setEditData] = useState({
    model: "",
    price: "",
    buyer: "",
    soldPrice: "",
  });

  const handleEditClick = (item) => {
    setIsEditing(item.ID);
    setInitialData({
      model: item.Model,
      price: item.Price,
      buyer: item.buyer,
      soldPrice: item.soldPrice,
    });
    setEditData({}); // Start with an empty object
  };

  const handleChange = (field, value) => {
    setEditData((prev) => ({
      ...prev,
      [field]: value !== initialData[field] ? value : undefined, // Set value if changed, otherwise undefined
    }));
  };

  // Function to handle saving the edited data
  const handleSave = async (id) => {
    const completeEditData = {
      model: editData.model !== undefined ? editData.model : initialData.model,
      price: editData.price !== undefined ? editData.price : initialData.price,
      buyer: editData.buyer !== undefined ? editData.buyer : initialData.buyer,
      soldPrice:
        editData.soldPrice !== undefined
          ? editData.soldPrice
          : initialData.soldPrice,
    };

    try {
      setLoading(true);
      const response = await axios.put(
        `${apiUrl}/updateEthioOthers/${id}`,
        completeEditData
      );
      setData(data.map((item) => (item.ID === id ? response.data : item)));
      setIsEditing(null);
      setLoading(false);
      fetchData();
    } catch (error) {
      setLoading(false);
      setErrors(error.response?.data?.message || "An error occurred");
    }
  };

  const filterByModel = (data, model) => {
    if (!model) return data;
    return data.filter((item) => item.Model === model); // Adjust as needed to match your Model field case
  };

  const filterByMonth = (data, month) => {
    if (!month) return data;
    return data.filter((item) => {
      const itemMonth = new Date(item.TimeStamp).getMonth() + 1; // getMonth is 0-indexed
      return itemMonth === parseInt(month);
    });
  };

  const filterByDay = (data, day, month) => {
    if (!day || !month) return data; // Ensure month is selected
    return data.filter((item) => {
      const itemDate = new Date(item.TimeStamp);
      const itemMonth = itemDate.getMonth() + 1;
      const itemDay = itemDate.getDate();
      return itemMonth === parseInt(month) && itemDay === parseInt(day); // Filter by day within the selected month
    });
  };

  // Calculate the number of days for the selected month
  const getDaysInMonth = (month) => {
    const year = new Date().getFullYear(); // Use the current year
    return new Date(year, month, 0).getDate(); // Get the last day of the month
  };

  const handleClear = () => {
    setFilterMonth("");
    setFilterDay("");
    setFilterStatusP("");
    setFilterModel("");
  };

  const filterByMonthAll = (month = currentMonthShortForm()) => {
    if (month === "") {
      setFilteredData(data);
    } else {
      const filtered = data.filter((item) =>
        item.OrderNumber.startsWith(`EOP${month}`)
      );
      setFilteredData(filtered);
      setSelectedMonth(month);
      const sum = filtered.reduce(
        (acc, item) => acc + parseFloat(item.Price || 0),
        0
      );
      const receivedTotal = filtered.filter(
        (item) => item.Status === "Received"
      ).length;
      const sentTotal = filtered.filter(
        (item) => item.Status === "Sent"
      ).length;
      const ordered = filtered.length;

      setTotalSent(sentTotal);
      setTotalReceivedCal(receivedTotal);
      setTotalPrice(sum);
      setTotalOrder(ordered);
    }
  };

  const handleMonthSelect = (month) => {
    setSelectedMonth(month);
    filterByMonthAll(month); // Hide the dropdown after selection
  };
  const [isMobile, setIsMobile] = useState(false);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 768); // Mobile if width <= 768px
  };

  useEffect(() => {
    handleResize(); // Check initially
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const totalExpense = filteredData.reduce(
    (acc, item) => acc + Number(item.price || 0),
    0
  );
  const totalSold = filteredData.reduce(
    (acc, item) => acc + Number(item.soldPrice || 0),
    0
  );
  const totalCom2 = filteredData.reduce(
    (acc, item) => acc + Number(item.com2 || 0),
    0
  );
  const totalDelivery = filteredData.reduce(
    (acc, item) => acc + Number(item.Delivery || 0),
    0
  );

  const updateSeller = async (itemId, seller) => {
    try {
      setLoading(true);
      await axios.put(
        `${apiUrl}/updateSellerEthioOther`,
        { id: itemId, seller },
        {
          headers: {
            Authorization: `Bearer ${userId}`,
          },
        }
      );
      setLoading(false);
      // Fetch updated data after successful status update
      fetchData();
    } catch (error) {
      setLoading(false);
      setErrors(error.response?.data?.message || "An error occurred");
    }
  };

  const handleOptionSelectSeller = (index, itemId, seller) => {
    setDropdownOpenSeller(null); // Close the dropdown
    // Update the status in the frontend optimistically
    setData(
      data.map((item) =>
        item.ID === itemId ? { ...item, seller: seller } : item
      )
    );
    // Update the status in the backend
    updateSeller(itemId, seller);
  };

  return (
    <div className="justify-center align-center border-1 border-slate-200 mt-20 w-11/12 mb-20 h-screen px-5 rounded-md">
      <div className="flex flex-col my-2">
        <h1 className="text-3xl font-bold text-gray-800">Other Products</h1>
      </div>

      <MonthFilter
        months={months}
        selectedMonth={selectedMonth}
        handleMonthSelect={handleMonthSelect}
        selectedYear={selectedYear}
        handleYearChange={handleYearChange}
        filterDay={filterDay}
        setFilterDay={setFilterDay}
        filterStatusP={filterStatusP}
        setFilterStatusP={setFilterStatusP}
        filterModel={filterModel}
        setFilterModel={setFilterModel}
        handleClear={handleClear}
        getDaysInMonth={getDaysInMonth}
        isMobile={isMobile}
      />

      <div className="relative max-h-[80vh] overflow-y-auto overflow-x-auto custom-scrollbar shadow-2xl rounded-2xl border border-slate-200 bg-white">
        <table className="min-w-full text-sm text-left text-slate-700 whitespace-nowrap">
          <thead className="sticky top-0 z-20 bg-slate-800 text-white uppercase text-xs font-semibold tracking-widest shadow-md">
            <tr>
              <th className="px-4 py-4 z-20 border-b border-slate-700">
                #
              </th>
              <th className="px-4 py-4 z-20 border-b border-slate-700">
                ItemName
              </th>
              <th className="px-4 py-4 z-20 border-b border-slate-700">
                Price
              </th>
              <th className="px-4 py-4 z-20 border-b border-slate-700">
                Buyer
              </th>
              <th className="px-4 py-4 z-20 border-b border-slate-700">
                Sold Price
              </th>
              <th className="px-4 py-4 z-20 border-b border-slate-700 text-green-400">
                Profit
              </th>
              <th className="px-4 py-4 z-20 border-b border-slate-700">
                Seller
              </th>
              <th className="px-4 py-4 z-20 border-b border-slate-700">
                Status
              </th>
            </tr>
          </thead>
          <tbody>
            {filteredData.map((item, index) => {
              const profit = () => {
                totalProfit += item.soldPrice - item.price;
                return item.soldPrice - item.price;
              };
              return (
                <tr key={item.ID} className=" border-b-1 border-slate-600">
                  {isEditing === item.ID ? (
                    <>
                      <td className="text-left m-0 bg-gray-100">
                        {item.OrderNumber}
                      </td>
                      <td className="text-left m-0 bg-gray-200">
                        <input
                          className="border w-full"
                          type="text"
                          value={
                            editData.model !== undefined
                              ? editData.model
                              : item.ItemName
                          }
                          onChange={(e) =>
                            handleChange("model", e.target.value)
                          }
                        />
                      </td>
                      <td className="text-left m-0 bg-gray-100">
                        <input
                          className="border w-full"
                          type="text"
                          placeholder="price"
                          value={
                            editData.price !== undefined
                              ? editData.price
                              : item.price
                          }
                          onChange={(e) =>
                            handleChange("price", e.target.value)
                          }
                        />
                      </td>

                      <td className="text-left m-0 bg-gray-200">
                        <input
                          className="border w-full"
                          type="text"
                          placeholder="buyer"
                          value={
                            editData.buyer !== undefined
                              ? editData.buyer
                              : item.buyer
                          }
                          onChange={(e) =>
                            handleChange("buyer", e.target.value)
                          }
                        />
                      </td>
                      <td className="text-left m-0 bg-gray-100">
                        <input
                          className="border w-full"
                          type="text"
                          placeholder="price"
                          value={
                            editData.soldPrice !== undefined
                              ? editData.soldPrice
                              : item.soldPrice
                          }
                          onChange={(e) =>
                            handleChange("soldPrice", e.target.value)
                          }
                        />
                      </td>
                      <td className="text-left m-0 bg-gray-200">{profit()}</td>
                      <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-50 z-0">
                        <div className="relative inline-block text-left z-0">
                          <div className="flex flex-row justify-around z-0">
                            <button
                              type="button"
                              className={`inline-flex justify-around gap-x-1.5 rounded-md w-20 mr-1 py-2 text-sm font-semibold shadow-sm hover:bg-gray-500
                                            ${item.seller === ""
                                  ? "bg-black text-white"
                                  : ""
                                }`}
                              id="menu-button-seller"
                              aria-expanded={dropdownOpenSeller === index}
                              aria-haspopup="true"
                              onClick={() => toggleDropdownSeller(index)}
                            >
                              {item.seller || "select"}
                              <svg
                                className="-mr-1 h-5 w-5 text-gray-400"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                                aria-hidden="true"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                                  clipRule="evenodd"
                                />
                              </svg>
                            </button>
                          </div>
                          {dropdownOpenSeller === index && (
                            <div
                              className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
                              aria-orientation="vertical"
                              aria-labelledby="menu-button-seller"
                              tabIndex="-1"
                            >
                              <div className="py-1" ref={dropdownRefSeller}>
                                <button
                                  className="block w-full px-4 py-2 text-left text-sm text-gray-700"
                                  role="menuitem"
                                  tabIndex="-1"
                                  onClick={() =>
                                    handleOptionSelectSeller(
                                      index,
                                      item.ID,
                                      "Yeabkal"
                                    )
                                  }
                                >
                                  Yeabkal
                                </button>

                                <button
                                  className="block w-full px-4 py-2 text-left text-sm text-gray-700"
                                  role="menuitem"
                                  tabIndex="-1"
                                  onClick={() =>
                                    handleOptionSelectSeller(
                                      index,
                                      item.ID,
                                      "Natnael"
                                    )
                                  }
                                >
                                  Natnael
                                </button>
                                <button
                                  className="block w-full px-4 py-2 text-left text-sm text-gray-700"
                                  role="menuitem"
                                  tabIndex="-1"
                                  onClick={() =>
                                    handleOptionSelectSeller(
                                      index,
                                      item.ID,
                                      "Yeabtsega"
                                    )
                                  }
                                >
                                  Yeabtsega
                                </button>
                                <button
                                  className="block w-full px-4 py-2 text-left text-sm text-gray-700"
                                  role="menuitem"
                                  tabIndex="-1"
                                  onClick={() =>
                                    handleOptionSelectSeller(
                                      index,
                                      item.ID,
                                      "Mihret"
                                    )
                                  }
                                >
                                  Mihret
                                </button>
                              </div>
                            </div>
                          )}
                        </div>
                      </td>
                      <td className="text-left m-0 bg-gray-200">
                        <div className="relative inline-block text-left">
                          <div className="flex flex-row justify-around">
                            <p className="inline-flex justify-around gap-x-1.5 rounded-md bg-gray-100  w-20 mr-1 py-2 text-sm font-semibold text-blue-900 shadow-sm  hover:bg-gray-50">
                              {item.ourStat || "Options"}
                            </p>
                          </div>
                        </div>
                      </td>
                      <td className="flex flex-row text-left m-0 bg-gray-100">
                        <button
                          className="inline-flex justify-around gap-x-1.5 rounded-md bg-gray-100  w-12 mr-1 py-2 text-sm font-semibold text-blue-900 shadow-sm  hover:bg-gray-50"
                          onClick={() => handleSave(item.ID)}
                        >
                          Save
                        </button>
                        <button
                          className="inline-flex justify-around gap-x-1.5 rounded-md bg-red-500  w-12 mr-1 py-2 text-sm font-semibold text-blue-900 shadow-sm  hover:bg-red-300"
                          onClick={() => setIsEditing(null)}
                        >
                          Cancel
                        </button>
                      </td>
                    </>
                  ) : (
                    <>
                      <td className="border-b border-slate-600 text-left bg-gray-100">
                        {item.OrderNumber}
                      </td>
                      <td className="border-b border-slate-600 text-left bg-gray-200">
                        {item.ItemName}
                      </td>
                      <td className="border-b border-slate-600 text-left bg-gray-100">
                        {item.price}
                      </td>
                      <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-200">
                        {item.buyer}
                      </td>
                      <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-100">
                        {item.soldPrice}
                      </td>
                      <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-200">
                        {profit()}
                      </td>
                      <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-50 z-0">
                        <div className="relative inline-block text-left z-0">
                          <div className="flex flex-row justify-around z-0">
                            <button
                              type="button"
                              className={`inline-flex justify-around gap-x-1.5 rounded-md w-20 mr-1 py-2 text-sm font-semibold shadow-sm hover:bg-gray-500
                                            ${item.seller === ""
                                  ? "bg-black text-white"
                                  : ""
                                }`}
                              id="menu-button-seller"
                              aria-expanded={dropdownOpenSeller === index}
                              aria-haspopup="true"
                              onClick={() => toggleDropdownSeller(index)}
                            >
                              {item.seller || "select"}
                              <svg
                                className="-mr-1 h-5 w-5 text-gray-400"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                                aria-hidden="true"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                                  clipRule="evenodd"
                                />
                              </svg>
                            </button>
                          </div>
                          {dropdownOpenSeller === index && (
                            <div
                              className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
                              aria-orientation="vertical"
                              aria-labelledby="menu-button-seller"
                              tabIndex="-1"
                            >
                              <div className="py-1" ref={dropdownRefSeller}>
                                <button
                                  className="block w-full px-4 py-2 text-left text-sm text-gray-700"
                                  role="menuitem"
                                  tabIndex="-1"
                                  onClick={() =>
                                    handleOptionSelectSeller(
                                      index,
                                      item.ID,
                                      "Yeabkal"
                                    )
                                  }
                                >
                                  Yeabkal
                                </button>

                                <button
                                  className="block w-full px-4 py-2 text-left text-sm text-gray-700"
                                  role="menuitem"
                                  tabIndex="-1"
                                  onClick={() =>
                                    handleOptionSelectSeller(
                                      index,
                                      item.ID,
                                      "Natnael"
                                    )
                                  }
                                >
                                  Natnael
                                </button>
                                <button
                                  className="block w-full px-4 py-2 text-left text-sm text-gray-700"
                                  role="menuitem"
                                  tabIndex="-1"
                                  onClick={() =>
                                    handleOptionSelectSeller(
                                      index,
                                      item.ID,
                                      "Yeabtsega"
                                    )
                                  }
                                >
                                  Yeabtsega
                                </button>
                                <button
                                  className="block w-full px-4 py-2 text-left text-sm text-gray-700"
                                  role="menuitem"
                                  tabIndex="-1"
                                  onClick={() =>
                                    handleOptionSelectSeller(
                                      index,
                                      item.ID,
                                      "Mihret"
                                    )
                                  }
                                >
                                  Mihret
                                </button>
                              </div>
                            </div>
                          )}
                        </div>
                      </td>

                      <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-100">
                        <div className="relative inline-block text-left">
                          <div className="flex flex-row justify-around">
                            <button
                              type="button"
                              className={`inline-flex justify-around gap-x-1.5 rounded-md w-20 mr-1 py-2 text-sm font-semibold shadow-sm hover:bg-gray-500
                                            ${item.ourStat === "Sold"
                                  ? "bg-green-500 text-white"
                                  : ""
                                }
                                            ${item.ourStat === "Received"
                                  ? "bg-blue-500 text-white"
                                  : ""
                                }
                                            ${item.ourStat === "Sent"
                                  ? "bg-yellow-500 text-white"
                                  : ""
                                }
                                            ${item.ourStat === "Returned"
                                  ? "bg-purple-500 text-white"
                                  : ""
                                }
                                            ${item.ourStat === "Unpaid"
                                  ? "bg-red-500 text-white"
                                  : ""
                                }
                                            ${!item.ourStat
                                  ? "bg-gray-100 text-blue-900"
                                  : ""
                                }`}
                              id="menu-button"
                              aria-expanded={dropdownOpen === index}
                              aria-haspopup="true"
                              onClick={() => toggleDropdown(index)}
                            >
                              {item.ourStat || "options"}
                              <svg
                                className="-mr-1 h-5 w-5 text-gray-400"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                                aria-hidden="true"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                                  clipRule="evenodd"
                                />
                              </svg>
                            </button>
                          </div>
                          {dropdownOpen === index && (
                            <div
                              className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
                              aria-orientation="vertical"
                              aria-labelledby="menu-button"
                              tabIndex="-1"
                            >
                              <div className="py-1" ref={dropdownRef}>
                                <button
                                  className="block w-full text-left text-sm text-gray-700 "
                                  role="menuitem"
                                  tabIndex="-1"
                                  onClick={() =>
                                    handleOptionSelect(index, item.ID, "Sold")
                                  }
                                >
                                  Sold
                                </button>
                                <button
                                  className="block w-full text-left text-sm text-gray-700"
                                  role="menuitem"
                                  tabIndex="-1"
                                  onClick={() =>
                                    handleOptionSelect(
                                      index,
                                      item.ID,
                                      "Received"
                                    )
                                  }
                                >
                                  Received
                                </button>
                                <button
                                  className="block w-full text-left text-sm text-gray-700"
                                  role="menuitem"
                                  tabIndex="-1"
                                  onClick={() =>
                                    handleOptionSelect(index, item.ID, "Custom")
                                  }
                                >
                                  Custom
                                </button>
                                <button
                                  className="block w-full text-left text-sm text-gray-700"
                                  role="menuitem"
                                  tabIndex="-1"
                                  onClick={() =>
                                    handleOptionSelect(
                                      index,
                                      item.ID,
                                      "Returned"
                                    )
                                  }
                                >
                                  Returned
                                </button>
                                <button
                                  className="block w-full text-left text-sm text-gray-700"
                                  role="menuitem"
                                  tabIndex="-1"
                                  onClick={() =>
                                    handleOptionSelect(index, item.ID, "Unpaid")
                                  }
                                >
                                  Unpaid
                                </button>
                                <button
                                  className="block w-full text-left text-sm text-gray-700"
                                  role="menuitem"
                                  tabIndex="-1"
                                  onClick={() =>
                                    handleOptionSelect(index, item.ID, "")
                                  }
                                >
                                  clear
                                </button>
                              </div>
                            </div>
                          )}
                        </div>
                      </td>
                      <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-200">
                        <button
                          className="inline-flex justify-around gap-x-1.5 rounded-md bg-gray-700 w-12 mr-1 py-2 text-sm font-semibold  shadow-sm  hover:bg-gray-500 text-white"
                          onClick={() => handleEditClick(item)}
                        >
                          Edit
                        </button>
                      </td>
                    </>
                  )}
                </tr>
              );
            })}
            <tr>
              <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-100 font-bold">
                Total፡{filteredData.length}
              </td>
              <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-200"></td>
              <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-100 font-bold">
                {totalExpense}
              </td>
              <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-200 font-bold"></td>
              <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-100 font-bold">
                {totalSold}
              </td>
              <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-200">
                {totalProfit}
              </td>
              <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-100"></td>
              <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-200"></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default EthioOthers;
